import { useState, useRef, useEffect } from 'react'
import { CarnetSanteForm, AttestationVetForm, IdentificationForm, CessionForm } from '../admin/DocForms'
import { animalDocsAPI, usersAPI } from '../../api'
import useBodyScrollLock from '../../hooks/useBodyScrollLock'
import './AdminFormalitesPage.css'

/* ─────────────────────────────────────────────────────────────
   Logo cache (identique AdminDashboard)
───────────────────────────────────────────────────────────── */
let _cachedLogoAfp = null
const _getLogoAfp = async () => {
  if (_cachedLogoAfp) return _cachedLogoAfp
  try {
    const r = await fetch(require('../../assets/monlogo.jpeg'))
    const b = await r.blob()
    _cachedLogoAfp = await new Promise(res => { const rd = new FileReader(); rd.onload = () => res(rd.result); rd.readAsDataURL(b) })
  } catch (e) {}
  return _cachedLogoAfp
}

/* ─────────────────────────────────────────────────────────────
   Générateurs PDF (copies exactes AdminDashboard, standalone)
───────────────────────────────────────────────────────────── */
const _pdfHeaderAfp = async (doc, W, M, N, G, WH, hH) => {
  const logo = await _getLogoAfp()
  const lZW = 50, lS = 28
  doc.setFillColor(...WH); doc.rect(0, 0, lZW, hH, 'F')
  doc.setFillColor(...N);  doc.rect(lZW, 0, W - lZW, hH, 'F')
  doc.setFillColor(...G);  doc.rect(lZW - 1.5, 0, 2, hH, 'F')
  doc.setFillColor(...G);  doc.rect(0, hH, W, 1, 'F')
  if (logo) { try { doc.addImage(logo, 'JPEG', (lZW - lS) / 2, (hH - lS) / 2, lS, lS) } catch (e) {} }
  doc.setTextColor(...WH); doc.setFontSize(13); doc.setFont('helvetica', 'bold')
  doc.text('ANIMAUX POUR ADOPTION DE LA FRANCE', W - M, 14, { align: 'right' })
  doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(180, 200, 230)
  doc.text('animauxadoption.fr', W - M, 21, { align: 'right' })
  doc.setFillColor(...N); doc.rect(0, hH, W, 0.5, 'F')
}
const _pdfFooterAfp = (doc, H, W, N, G, WH, left, right) => {
  const sf = s => s == null ? '' : String(s).replace(/[^\x00-\xFF]/g, '')
  doc.setFillColor(...N); doc.rect(0, H - 10, W, 10, 'F')
  doc.setFillColor(...G); doc.rect(0, H - 10, W, 0.8, 'F')
  doc.setTextColor(180, 205, 235); doc.setFontSize(6.5); doc.setFont('helvetica', 'normal')
  doc.text(sf(left) || ' ', 14, H - 4)
  if (right) { doc.setTextColor(...G); doc.setFont('helvetica', 'bold'); doc.text(sf(right) || ' ', W - 14, H - 4, { align: 'right' }) }
}

const generateCarnetPDF = async (d, vaccins, antiparas, sig, photo, cachet) => {
  const { jsPDF } = await import('jspdf')
  const doc = new jsPDF({ unit: 'mm', format: 'a4' })
  const W=210,H=297,M=12,CW=W-M*2
  const NV=[30,58,120],GD=[217,174,92],WH=[255,255,255],BD=[203,213,225]
  const safe=s=>{if(s==null||s==='')return '';return String(s).replace(/[\u2018\u2019]/g,"'").replace(/[\u201C\u201D]/g,'"').replace(/\u2014/g,'-').replace(/\u2013/g,'-').replace(/[^\x00-\xFF]/g,'')}
  const t=(s,x,y2,o={})=>doc.text(safe(String(s==null||s===undefined?'':s))||' ',x,y2,o)
  const fmt=dt=>{if(!dt)return '-';try{return new Date(dt).toLocaleDateString('fr-FR')}catch(e){return String(dt)||'-'}}
  const docRef=d.docNumber||('CS-'+new Date().getFullYear()+'-'+(d.name||'ANI').replace(/\s+/g,'').slice(0,6).toUpperCase())
  const hH=42
  const secBand=(label,x,yy,w,h=7)=>{doc.setFillColor(...NV);doc.rect(x,yy,w,h,'F');doc.setTextColor(...WH);doc.setFontSize(8.5);doc.setFont('helvetica','bold');t(label,x+4,yy+h-1.5)}
  const fld=(lbl,val,x,yy,w)=>{doc.setTextColor(...NV);doc.setFontSize(6.5);doc.setFont('helvetica','bold');t(lbl,x,yy);doc.setTextColor(0,0,0);doc.setFontSize(9);doc.setFont('helvetica','normal');t(safe(String(val||'')).slice(0,Math.floor(w/1.5)),x,yy+7);doc.setDrawColor(...BD);doc.setLineWidth(0.2);doc.line(x,yy+9.5,x+w,yy+9.5)}
  const PAGE_BOTTOM=H-12
  const drawFooter=()=>{doc.setFillColor(...NV);doc.rect(0,H-10,W,10,'F');doc.setFillColor(...GD);doc.rect(0,H-10,W,0.8,'F');doc.setTextColor(180,205,235);doc.setFontSize(6.5);doc.setFont('helvetica','normal');t('Animaux pour Adoption de la France  -  Carnet de Sante  -  Document officiel a conserver',W/2,H-4,{align:'center'});doc.setTextColor(...GD);doc.setFontSize(6.5);doc.setFont('helvetica','bold');t(docRef,W-M,H-4,{align:'right'})}
  const drawContH=()=>{doc.setFillColor(...NV);doc.rect(0,0,W,11,'F');doc.setFillColor(...GD);doc.rect(0,11,W,0.6,'F');doc.setTextColor(...GD);doc.setFontSize(7.5);doc.setFont('helvetica','bold');t('CARNET DE SANTE - Suite',M,7.5);doc.setTextColor(180,205,235);doc.setFontSize(6.5);doc.setFont('helvetica','normal');t(docRef,W-M,7.5,{align:'right'})}
  const chkPage=(need)=>{if(y+need>PAGE_BOTTOM){drawFooter();doc.addPage();drawContH();y=16}}
  let y=0
  doc.setFillColor(...NV);doc.rect(0,0,W,hH,'F');doc.setFillColor(...GD);doc.rect(0,0,2,hH,'F')
  doc.setTextColor(180,205,235);doc.setFontSize(8);doc.setFont('helvetica','normal');t('LE CARNET',W/2,13,{align:'center'})
  doc.setTextColor(255,255,255);doc.setFontSize(20);doc.setFont('helvetica','bold');t('DE SANTE',W/2,28,{align:'center'})
  doc.setFillColor(...GD);doc.rect(W/2-40,32,80,0.7,'F')
  doc.setFontSize(8);doc.setFont('helvetica','bold')
  const bW=doc.getTextWidth(docRef)+10
  try{doc.setFillColor(...GD);doc.roundedRect(W-M-bW,11,bW,9,2,2,'F')}catch(e){doc.setFillColor(...GD);doc.rect(W-M-bW,11,bW,9,'F')}
  doc.setTextColor(...NV);t(docRef,W-M-bW/2,17.5,{align:'center'})
  doc.setFillColor(...GD);doc.rect(0,hH,W,1,'F');y=hH
  doc.setFillColor(252,246,226);doc.rect(0,y,W,10,'F')
  const nlb='DE:',nVal=safe(d.name||'').toUpperCase()
  doc.setFontSize(7.5);doc.setFont('helvetica','bold');doc.setTextColor(...GD)
  const nlbW=doc.getTextWidth(nlb)
  doc.setFontSize(12)
  const nValW=doc.getTextWidth(nVal)
  const bStart=W/2-(nlbW+5+nValW)/2
  doc.setFontSize(7.5);doc.setFont('helvetica','bold');doc.setTextColor(...GD);t(nlb,bStart,y+7)
  doc.setFontSize(12);doc.setFont('helvetica','bold');doc.setTextColor(...NV);t(nVal,bStart+nlbW+5,y+7)
  doc.setFillColor(...GD);doc.rect(0,y+10,W,0.5,'F');y+=11
  secBand("IDENTITE DE L'ANIMAL",M,y,CW);y+=7
  const phW=46,phH=62,iX=M+phW+4,iW=CW-phW-4,hfw=(iW-6)/2
  const specStr=safe(d.species||'Animal').toUpperCase()+(d.breed?' - '+safe(d.breed).toUpperCase():'')+(d.age?' ['+safe(d.age)+']':'')
  if(photo){try{doc.addImage(photo,'JPEG',M,y,phW,phH)}catch(e){try{doc.addImage(photo,'PNG',M,y,phW,phH)}catch(e2){}}}
  else{doc.setFillColor(241,245,249);doc.rect(M,y,phW,phH,'F');doc.setDrawColor(...GD);doc.setLineWidth(0.5);doc.setLineDashPattern([2,1.5],0);doc.rect(M,y,phW,phH);doc.setLineDashPattern([],0);doc.setTextColor(...NV);doc.setFontSize(8);doc.setFont('helvetica','normal');t('PHOTO',M+phW/2,y+phH/2-4,{align:'center'});t('ANIMAL',M+phW/2,y+phH/2+4,{align:'center'})}
  doc.setFillColor(...GD);doc.rect(iX,y,iW,7.5,'F');doc.setTextColor(...NV);doc.setFontSize(8.5);doc.setFont('helvetica','bold');t(specStr,iX+4,y+5.5)
  let gy=y+7.5+3
  fld('Nom',safe(d.name||''),iX,gy,hfw);fld('Espece',safe(d.species||''),iX+hfw+6,gy,hfw);gy+=14
  fld('Race',safe(d.breed||''),iX,gy,hfw);fld('Age',safe(d.age||''),iX+hfw+6,gy,hfw);gy+=14
  fld('Sexe',safe(d.sex||''),iX,gy,hfw);fld('Sterilise(e)',safe(d.sterilise||''),iX+hfw+6,gy,hfw);gy+=14
  fld('Poids (kg)',safe(d.poids?String(d.poids)+' kg':''),iX,gy,iW)
  y+=phH+5
  chkPage(60);secBand('PROPRIETAIRE',M,y,CW);y+=7
  doc.setFillColor(248,250,252);doc.rect(M,y,CW,50,'F')
  const pw2=(CW-8)/2
  fld('Nom du proprietaire',safe(d.proprietaire_nom||''),M+4,y+4,pw2);fld('Telephone',safe(d.proprietaire_tel||''),M+pw2+8,y+4,pw2)
  fld('Email',safe(d.proprietaire_email||''),M+4,y+19,pw2);fld('Adresse',safe(d.proprietaire_adresse||''),M+pw2+8,y+19,pw2)
  fld('Ville',safe(d.proprietaire_ville||''),M+4,y+34,pw2);fld('Code postal',safe(d.proprietaire_cp||''),M+pw2+8,y+34,pw2)
  y+=55
  chkPage(58);secBand('CABINET VETERINAIRE',M,y,CW);y+=7
  doc.setFillColor(248,250,252);doc.rect(M,y,CW,48,'F')
  fld('Nom du cabinet / Veterinaire traitant',safe((d.veterinaire_cabinet||'')+(d.attestation_veterinaire?' - Dr. '+d.attestation_veterinaire:'')+(d.attestation_ordre?' (Ordre N\u00b0 '+d.attestation_ordre+')':'')),M+4,y+4,CW-8)
  const vc2=(CW-8)/2
  fld('Telephone',safe(d.veterinaire_tel||''),M+4,y+19,vc2);fld('Email',safe(d.veterinaire_email||''),M+vc2+8,y+19,vc2)
  fld('Adresse',safe(d.veterinaire_adresse||''),M+4,y+34,CW-8);y+=52
  if(vaccins&&vaccins.length>0){chkPage(24+vaccins.length*8);const hdrs=['VACCIN','DATE','RAPPEL','N\u00b0 LOT','STATUT'];const cols=[54,28,28,38,CW-148];const RH=8,THt=7,HH=6.5,totalH=THt+HH+vaccins.length*RH+2;secBand('CARNET DE VACCINATIONS',M,y,CW);doc.setFillColor(255,255,255);doc.rect(M,y+THt,CW,totalH-THt,'F');let ty=y+THt;doc.setFillColor(232,237,248);doc.rect(M,ty,CW,HH,'F');doc.setDrawColor(...BD);doc.setLineWidth(0.3);doc.line(M,ty+HH,M+CW,ty+HH);doc.setTextColor(...NV);doc.setFontSize(6.5);doc.setFont('helvetica','bold');let cx=M+3;hdrs.forEach((h,i)=>{t(h,cx,ty+4.5);cx+=cols[i]});ty+=HH;vaccins.forEach((v,ri)=>{doc.setFillColor(ri%2===0?255:248,ri%2===0?255:250,ri%2===0?255:252);doc.rect(M,ty,CW,RH,'F');if(ri<vaccins.length-1){doc.setDrawColor(...BD);doc.setLineWidth(0.15);doc.line(M,ty+RH,M+CW,ty+RH)}doc.setTextColor(30,41,59);doc.setFontSize(8);doc.setFont('helvetica','normal');const ok=v.rappel&&new Date(v.rappel)>new Date();const row=[safe(v.type||''),fmt(v.date),fmt(v.rappel),safe(v.lot||''),v.rappel?null:''];let cx2=M+3;row.forEach((cell,ci)=>{if(hdrs[ci]==='STATUT'&&v.rappel){doc.setFillColor(ok?220:254,ok?252:230,ok?220:210);doc.rect(cx2,ty+1.5,cols[ci]-4,RH-3,'F');doc.setTextColor(ok?22:150,ok?120:30,ok?60:40);doc.setFontSize(6.5);doc.setFont('helvetica','bold');t(ok?'A jour':'Rappel proche',cx2+(cols[ci]-4)/2,ty+5.5,{align:'center'});doc.setTextColor(30,41,59);doc.setFont('helvetica','normal');doc.setFontSize(8)}else{t(safe(String(cell||'')).slice(0,26),cx2,ty+5.5)};cx2+=cols[ci]});ty+=RH});y+=totalH+5}
  if(antiparas&&antiparas.length>0){chkPage(24+antiparas.length*8);const hdrs2=['TYPE','PRODUIT','DATE','PROCHAINE ECHEANCE'];const cols2=[34,64,34,CW-132];const RH2=8,THt2=7,HH2=6.5,totalH2=THt2+HH2+antiparas.length*RH2+2;secBand('TRAITEMENTS ANTIPARASITAIRES',M,y,CW);doc.setFillColor(255,255,255);doc.rect(M,y+THt2,CW,totalH2-THt2,'F');let ty2=y+THt2;doc.setFillColor(232,237,248);doc.rect(M,ty2,CW,HH2,'F');doc.setDrawColor(...BD);doc.setLineWidth(0.3);doc.line(M,ty2+HH2,M+CW,ty2+HH2);doc.setTextColor(...NV);doc.setFontSize(6.5);doc.setFont('helvetica','bold');let cx3=M+3;hdrs2.forEach((h,i)=>{t(h,cx3,ty2+4.5);cx3+=cols2[i]});ty2+=HH2;antiparas.forEach((a,ri)=>{doc.setFillColor(ri%2===0?255:248,ri%2===0?255:250,ri%2===0?255:252);doc.rect(M,ty2,CW,RH2,'F');if(ri<antiparas.length-1){doc.setDrawColor(...BD);doc.setLineWidth(0.15);doc.line(M,ty2+RH2,M+CW,ty2+RH2)}doc.setTextColor(30,41,59);doc.setFontSize(8);doc.setFont('helvetica','normal');const row2=[safe(a.type||''),safe(a.produit||''),fmt(a.date),fmt(a.prochaine_date)];let cx4=M+3;row2.forEach((cell,ci)=>{t(safe(String(cell||'')).slice(0,30),cx4,ty2+5.5);cx4+=cols2[ci]});ty2+=RH2});y+=totalH2+5}
  chkPage(50);secBand('EXAMEN CLINIQUE - ATTESTATION VETERINAIRE',M,y,CW);y+=7
  const exH=36;doc.setFillColor(255,255,255);doc.rect(M,y,CW,exH,'F')
  const ec1w=(CW-6)/3,ec2w=(CW-6)/3,ec3w=CW-6-ec1w-ec2w,ec1x=M+3,ec2x=ec1x+ec1w+3,ec3x=ec2x+ec2w+3
  doc.setDrawColor(...BD);doc.setLineWidth(0.2);doc.line(ec2x-1.5,y,ec2x-1.5,y+exH);doc.line(ec3x-1.5,y,ec3x-1.5,y+exH)
  fld("Date de l'examen",fmt(d.attestation_date),ec1x,y+3,ec1w);fld('Validite',safe(d.attestation_validite||''),ec1x,y+18,ec1w)
  fld('Veterinaire',safe(d.attestation_veterinaire?'Dr. '+d.attestation_veterinaire:''),ec2x,y+3,ec2w);fld('N\u00b0 Ordre',safe(d.attestation_ordre||''),ec2x,y+18,ec2w)
  doc.setTextColor(...NV);doc.setFontSize(6.5);doc.setFont('helvetica','bold');t('Observations medicales',ec3x,y+5)
  doc.setTextColor(0,0,0);doc.setFontSize(8.5);doc.setFont('helvetica','italic');const obsL=doc.splitTextToSize(safe(d.attestation_observations||''),ec3w);doc.text(obsL.slice(0,3),ec3x,y+13);y+=exH+5
  chkPage(50);secBand('SIGNATURES & CACHET',M,y,CW);y+=7
  const sigH=36,sigW=(CW-6)/2,cX=M+sigW+6
  doc.setFillColor(250,251,253);doc.rect(M,y,sigW,sigH,'F');doc.setFillColor(250,251,253);doc.rect(cX,y,sigW,sigH,'F')
  doc.setTextColor(...NV);doc.setFontSize(7);doc.setFont('helvetica','bold');t('SIGNATURE DU VETERINAIRE',M+sigW/2,y+6,{align:'center'})
  doc.setDrawColor(...GD);doc.setLineWidth(0.5);doc.setLineDashPattern([2,1.5],0);doc.rect(M+6,y+9,sigW-12,sigH-18);doc.setLineDashPattern([],0)
  if(sig){try{doc.addImage(sig,'PNG',M+8,y+11,sigW-16,sigH-22)}catch(e){}}
  doc.setDrawColor(...BD);doc.setLineWidth(0.3);doc.line(M+6,y+sigH-7,M+sigW-6,y+sigH-7)
  doc.setTextColor(100,116,139);doc.setFontSize(6.5);doc.setFont('helvetica','italic');t(safe(d.attestation_veterinaire?'Dr. '+d.attestation_veterinaire+' - Veterinaire':'Veterinaire'),M+sigW/2,y+sigH-3,{align:'center'})
  doc.setTextColor(...NV);doc.setFontSize(7);doc.setFont('helvetica','bold');t('CACHET OFFICIEL',cX+sigW/2,y+6,{align:'center'})
  const cachetS=24
  if(cachet){try{doc.addImage(cachet,'PNG',cX+sigW/2-cachetS/2,y+10,cachetS,cachetS)}catch(e){}}
  else{doc.setDrawColor(...GD);doc.setLineWidth(0.5);doc.setLineDashPattern([2,1.5],0);doc.circle(cX+sigW/2,y+20,12,'S');doc.setLineDashPattern([],0)}
  doc.setTextColor(150,165,185);doc.setFontSize(6.5);doc.setFont('helvetica','italic');t('Cachet du cabinet',cX+sigW/2,y+sigH-3,{align:'center'})
  drawFooter();doc.save('carnet-sante-'+safe(d.name||'animal').replace(/\s+/g,'-')+'.pdf')
}

const generateAttestationPDF = async (d, sig, stamp) => {
  const { jsPDF } = await import('jspdf')
  const doc = new jsPDF({ unit:'mm', format:'a4' })
  const W=210,H=297,M=20,hH=38,N=[30,58,120],G=[217,174,92],WH=[255,255,255],DARK=[44,62,80],GREY=[108,117,125]
  const sf2=s=>s==null?'':String(s).replace(/[^\x00-\xFF]/g,'').replace(/\u2014/g,'-')||' '
  const tc=(...c)=>doc.setTextColor(...c);const txt=(s,x,y,o={})=>doc.text(sf2(s==null||s===''?'-':s),x,y,o)
  await _pdfHeaderAfp(doc,W,M,N,G,WH,hH)
  let y=hH+18
  tc(...N);doc.setFontSize(20);doc.setFont('helvetica','bold');txt('ATTESTATION V\u00c9T\u00c9RINAIRE',W/2,y,{align:'center'});y+=14
  tc(...DARK);doc.setFontSize(10);doc.setFont('helvetica','normal')
  const vetNom=d.vetNom||'[Nom et pr\u00e9nom]';const ordre=d.vetNumOrdre||'[N\u00b0 ordre]'
  txt('Je soussign\u00e9(e), Dr. ',M,y);const w1=doc.getTextWidth('Je soussign\u00e9(e), Dr. ')
  doc.setFont('helvetica','bold');txt(vetNom,M+w1,y);const w2=doc.getTextWidth(vetNom)
  doc.setFont('helvetica','normal');txt(', v\u00e9t\u00e9rinaire inscrit(e) \u00e0 l\u2019Ordre National des V\u00e9t\u00e9rinaires',M+w1+w2,y);y+=6
  txt('sous le num\u00e9ro ',M,y);const w3=doc.getTextWidth('sous le num\u00e9ro ')
  doc.setFont('helvetica','bold');txt(ordre+',',M+w3,y);const w4=doc.getTextWidth(ordre+',')
  doc.setFont('helvetica','normal');txt(' certifie avoir examin\u00e9 ce jour l\u2019animal ci-apr\u00e8s :',M+w3+w4,y);y+=12
  const aFields=[["Nom de l\u2019animal",d.animalNom||'[Nom]'],['Esp\u00e8ce',d.animalEspece||'[Esp\u00e8ce]'],['Race',d.animalRace||'[Race]'],['Sexe',d.animalSexe||'[Sexe]'],['Couleur',d.animalCouleur||'[Couleur]'],['Puc\u00e9',d.animalPuce||'[Oui/Non]'],["Propri\u00e9taire de l\u2019animal",d.proprietaireNom||'[Nom propri\u00e9taire]'],['Identification',d.animalId||'[N\u00b0 puce/tatouage]']]
  aFields.forEach(([label,val])=>{doc.setFont('helvetica','bold');tc(...N);doc.setFontSize(10);const lbl=label+' : ';txt(lbl,M+8,y);const lw2=doc.getTextWidth(lbl);doc.setFont('helvetica','normal');tc(...DARK);txt(val,M+8+lw2,y);y+=7});y+=4
  tc(...DARK);doc.setFontSize(10);doc.setFont('helvetica','normal');txt("Apr\u00e8s examen clinique, j\u2019atteste que l\u2019animal est :",M,y);y+=8
  ;['En bonne sant\u00e9 g\u00e9n\u00e9rale','\u00c0 jour de ses vaccinations obligatoires',"Ne pr\u00e9sente aucun signe de maladie contagieuse au moment de l\u2019examen",'Apte au transport auquel il est destin\u00e9'].forEach((label)=>{doc.setFillColor(30,58,120);doc.rect(M+8,y-2.8,2.2,2.2,'F');tc(...DARK);doc.setFontSize(10);doc.setFont('helvetica','normal');txt(label,M+13,y);y+=7});y+=8
  tc(...DARK);doc.setFontSize(10);doc.setFont('helvetica','normal');txt('Fait pour servir et valoir ce que de droit.',M,y);y+=16
  const dateStr=d.date?new Date(d.date).toLocaleDateString('fr-FR'):new Date().toLocaleDateString('fr-FR')
  const halfW=(W-M*2)/2,cxL=M+halfW/2,cxR=M+halfW+halfW/2
  tc(...N);doc.setFont('helvetica','bold');doc.setFontSize(10);txt('Fait \u00e0 '+(d.ville||'[Ville]')+', le '+dateStr,cxL,y,{align:'center'})
  tc(...GREY);doc.setFont('helvetica','italic');txt('Signature du v\u00e9t\u00e9rinaire',cxR,y,{align:'center'});y+=8
  const stampS=32;if(stamp){try{doc.addImage(stamp,'PNG',cxL-stampS/2,y,stampS,stampS)}catch(e){}}
  const sigW=55,sigH=24;if(sig){try{doc.addImage(sig,'PNG',cxR-sigW/2,y+2,sigW,sigH)}catch(e){}}else{doc.setDrawColor(180,180,200);doc.setLineWidth(0.3);doc.line(cxR-sigW/2,y+sigH,cxR+sigW/2,y+sigH)}
  _pdfFooterAfp(doc,H,W,N,G,WH,'Attestation v\u00e9t\u00e9rinaire \u2014 Animaux pour Adoption de la France','Document officiel \u2014 \u00e0 conserver avec l\u2019animal')
  doc.save('attestation-vet-'+(d.animalNom||'animal').replace(/\s+/g,'-')+'.pdf')
}

const generateIdentificationPDF = async (d) => {
  const { jsPDF } = await import('jspdf')
  const doc = new jsPDF({ unit:'mm', format:'a4' })
  const W=210,H=297,M=13,CW=W-M*2
  const safe=s=>{if(s==null||s==='')return '';return String(s).replace(/[\u2018\u2019\u2032]/g,"'").replace(/[\u201C\u201D]/g,'"').replace(/\u2014/g,'-').replace(/\u2013/g,'-').replace(/[^\x00-\xFF]/g,'')}
  const t=(s,x,y2,o={})=>doc.text(safe(String(s==null||s===undefined?'':s))||' ',x,y2,o)
  const fmt=dt=>{if(!dt)return '-';try{return new Date(dt).toLocaleDateString('fr-FR')}catch(e){return String(dt)||'-'}}
  let y=0
  doc.setFillColor(30,58,122);doc.rect(0,0,W,32,'F');doc.setTextColor(255,255,255)
  doc.setFontSize(11);doc.setFont('helvetica','bold');t('SOCIETE D\'IDENTIFICATION DES CARNIVORES DOMESTIQUES',W/2,9,{align:'center'})
  doc.setFontSize(7.5);doc.setFont('helvetica','normal');t('112-114 Avenue Gabriel Peri  -  94246 L\'HAY LES ROSES Cedex',W/2,15,{align:'center'})
  doc.setFontSize(9.5);doc.setFont('helvetica','bold');t('0 810 778 778',W/2,21.5,{align:'center'})
  doc.setFontSize(7);doc.setFont('helvetica','normal');doc.setTextColor(180,200,235);t(new Date().toLocaleDateString('fr-FR')+' '+new Date().toLocaleTimeString('fr-FR',{hour:'2-digit',minute:'2-digit'}),W/2,27.5,{align:'center'})
  y=32+7;doc.setTextColor(71,85,105);doc.setFontSize(8.5);doc.setFont('helvetica','normal');t('Madame, Monsieur,',M,y);y+=4.5
  const intro='Nous avons le plaisir de vous adresser la carte d\'identification de votre animal suite a l\'enregistrement de son identification et de vos coordonnees dans le Fichier National des Carnivores Domestiques (chiens, chats, furets).'
  const introLines=doc.splitTextToSize(intro,CW);doc.text(introLines,M,y);y+=introLines.length*3.9+7
  const TH=8.5,FH=11
  const section=(title,rows,y0)=>{
    let sH=TH,ri=0;while(ri<rows.length){sH+=FH;if(rows[ri][2]==='full'){ri++}else{ri+=2}}
    doc.setFillColor(255,255,255);doc.rect(M,y0,CW,sH,'F');doc.setDrawColor(203,213,225);doc.setLineWidth(0.35);doc.rect(M,y0,CW,sH)
    doc.setFillColor(241,245,249);doc.rect(M,y0,CW,TH,'F');doc.setFillColor(52,120,200);doc.rect(M,y0,3,TH,'F')
    doc.setDrawColor(203,213,225);doc.setLineWidth(0.3);doc.line(M,y0+TH,M+CW,y0+TH)
    doc.setTextColor(30,41,59);doc.setFontSize(7.5);doc.setFont('helvetica','bold');t(title.toUpperCase(),M+6,y0+6)
    const colW=CW/2,col2=M+colW;let ry=y0+TH
    const field=(label,val,fx,fw,fy)=>{const PAD=3;doc.setTextColor(22,163,74);doc.setFontSize(6.5);doc.setFont('helvetica','bold');t(label.toUpperCase(),fx+PAD,fy+3.5);doc.setFillColor(241,245,249);doc.rect(fx+PAD,fy+4.5,fw-PAD*2,5.5,'F');doc.setTextColor(30,41,59);doc.setFontSize(8);doc.setFont('helvetica','normal');t(safe(val||''),fx+PAD+2,fy+9)}
    let ri2=0;while(ri2<rows.length){const r=rows[ri2];if(r[2]==='full'){field(r[0],r[1],M,CW,ry);ry+=FH;ri2++;if(ri2<rows.length){doc.setDrawColor(203,213,225);doc.setLineWidth(0.25);doc.line(M,ry,M+CW,ry)}}else{field(r[0],r[1],M,colW,ry);doc.setDrawColor(203,213,225);doc.setLineWidth(0.25);doc.line(col2,ry,col2,ry+FH);if(rows[ri2+1]){field(rows[ri2+1][0],rows[ri2+1][1],col2,colW,ry)}ry+=FH;ri2+=2;if(ri2<rows.length){doc.setDrawColor(203,213,225);doc.setLineWidth(0.25);doc.line(M,ry,M+CW,ry)}}}
    return y0+sH+3
  }
  y=section("Identification de l'animal",[['Nom et prenom du proprietaire',d.ownerName||''],['Adresse complete',d.ownerAddress||''],['Tel 1',d.phone1||''],['E-mail',d.email||''],['Veterinaire traitant',d.veterinaireNom?(safe(d.veterinaireNom)+(d.veterinaireContact?' - '+safe(d.veterinaireContact):'')):'','full']],y)
  y=section('Description du '+(d.animalEspece||'chat').toLowerCase(),[['Date de naissance',fmt(d.birthDate)],['Race',d.breed||''],['Couleur',d.coat||''],['Poil',d.hairType||''],['Sexe',d.sex==='MALE'?'Male':(d.sex||'')],['Sterilise',d.sterilise||'Non'],["Nom d'usage",d.animalName||''],["Pays d'origine",d.paysOrigine||'France']],y)
  y+=5
  doc.setFillColor(248,250,252);doc.rect(0,H-8,W,8,'F');doc.setDrawColor(203,213,225);doc.setLineWidth(0.3);doc.line(0,H-8,W,H-8)
  doc.setTextColor(148,163,184);doc.setFontSize(6.5);doc.setFont('helvetica','normal');t('Carte generee le '+new Date().toLocaleDateString('fr-FR')+' - Document informatif',W/2,H-3,{align:'center'})
  doc.save('identification-'+(d.animalName||'animal').replace(/\s+/g,'-').replace(/[^\x00-\xFF]/g,'')+'.pdf')
}

const generateCessionPDF = async (f, adminSig, userSig) => {
  const { jsPDF } = await import('jspdf')
  const doc = new jsPDF({ unit:'mm', format:'a4' })
  const W=210,H=297,M=14,CW=W-M*2
  const safe=s=>{if(s==null||s==='')return '-';return String(s).replace(/[\u2018\u2019]/g,"'").replace(/[\u201C\u201D]/g,'"').replace(/\u2014/g,'-').replace(/[^\x00-\xFF]/g,'')}
  const t=(s,x,y2,o={})=>doc.text(safe(String(s==null||s===undefined?'':s))||' ',x,y2,o)
  const fmt=dt=>{if(!dt||dt==='\u2014')return '-';try{return new Date(dt).toLocaleDateString('fr-FR')}catch(e){return String(dt)||'-'}}
  const logo=await _getLogoAfp()
  const hH=38,lZW=50
  doc.setFillColor(255,255,255);doc.rect(0,0,lZW,hH,'F');doc.setFillColor(30,58,120);doc.rect(lZW,0,W-lZW,hH,'F')
  doc.setFillColor(217,174,92);doc.rect(lZW-1,0,2,hH,'F');doc.setFillColor(217,174,92);doc.rect(0,hH,W,0.8,'F')
  if(logo){try{doc.addImage(logo,'JPEG',(lZW-28)/2,(hH-28)/2,28,28)}catch(e){}}
  doc.setTextColor(255,255,255);doc.setFontSize(11);doc.setFont('helvetica','bold');t('ANIMAUX POUR ADOPTION DE LA FRANCE',W-M,10,{align:'right'})
  doc.setFontSize(8.5);doc.setFont('helvetica','normal');doc.setTextColor(180,200,230)
  t(safe(f.cedantAdresse||'123 Rue des Compagnons, 75001 Paris'),W-M,17,{align:'right'})
  t('Tel : '+safe(f.cedantTel||'+33 1 23 45 67 89'),W-M,23,{align:'right'})
  t('Email : '+safe(f.cedantEmail||'contact@animauxadoption.fr'),W-M,29,{align:'right'})
  let y=hH+10
  doc.setTextColor(30,58,120);doc.setFontSize(20);doc.setFont('helvetica','bold');t('TRANSFERT DE DOCUMENTS',W/2,y,{align:'center'});y+=7
  doc.setFontSize(9);doc.setFont('helvetica','normal');doc.setTextColor(100,116,139);t('Date : '+fmt(f.date||f.doc?.date),W/2,y,{align:'center'});y+=8
  const drawIS=(title,rows,y0)=>{doc.setTextColor(217,174,92);doc.setFontSize(9);doc.setFont('helvetica','bold');t(title.toUpperCase(),M,y0);y0+=2;doc.setDrawColor(217,174,92);doc.setLineWidth(0.2);doc.line(M,y0,M+CW,y0);y0+=5;rows.forEach(([lbl,val])=>{doc.setTextColor(18,34,74);doc.setFontSize(9);doc.setFont('helvetica','bold');t(lbl+' :',M,y0);doc.setTextColor(30,41,59);doc.setFont('helvetica','normal');t(safe(String(val||'\u2014')),50,y0);y0+=6.5});return y0+2}
  y=drawIS('INFORMATIONS DU CLIENT',[['Nom',f.acquereurNom||f.clientNom],['Email',f.acquereurEmail||f.clientEmail],['T\u00e9l\u00e9phone',f.acquereurTel],['Adresse',f.acquereurAdresse]],y)
  y=drawIS('INFORMATIONS DU PRESTATAIRE',[['Soci\u00e9t\u00e9',f.cedantNom||'Animaux pour Adoption de la France'],['T\u00e9l\u00e9phone',f.cedantTel||'\u2014'],['Email',f.cedantEmail||'contact@animauxadoption.fr'],['Adresse',f.cedantAdresse||'123 Rue des Compagnons, 75001 Paris']],y)
  y-=4;doc.setDrawColor(217,174,92);doc.setLineWidth(0.2);doc.line(M,y,M+CW,y);y+=9
  doc.setTextColor(18,34,74);doc.setFontSize(10);doc.setFont('helvetica','bold');t('Objet : Confirmation de transfert de documents',M,y);y+=10
  doc.setFont('helvetica','normal');doc.setTextColor(30,41,59);t('Madame, Monsieur '+safe(f.acquereurNom||f.clientNom||'')+',',M,y);y+=7
  const paras=['Par la pr\u00e9sente, la soci\u00e9t\u00e9 '+(f.cedantNom||'Animaux pour Adoption de la France')+' confirme le transfert des documents relatifs au dossier de cession de votre animal.','Ce document atteste de la remise de l\'ensemble des pi\u00e8ces n\u00e9cessaires \u00e0 la constitution de votre dossier de cession animalier.','Nous vous prions de bien vouloir v\u00e9rifier l\'exactitude des informations mentionn\u00e9es ci-dessus et de nous signaler toute anomalie dans les plus brefs d\u00e9lais.']
  paras.forEach(para=>{const lines=doc.splitTextToSize(para,CW);doc.text(lines,M,y);y+=lines.length*4.0+3})
  doc.setTextColor(217,174,92);doc.setFontSize(9);doc.setFont('helvetica','bold');t('LISTE DES DOCUMENTS TRANSFERES',M,y);y+=2
  doc.setDrawColor(217,174,92);doc.setLineWidth(0.2);doc.line(M,y,M+CW,y);y+=5
  const cols=[8,72,20,42,24],hdrs=['N\u00b0','Document','Nb','R\u00e9f\u00e9rence','Date'],RH=8
  doc.setFillColor(30,58,120);doc.rect(M,y,CW,RH,'F');doc.setTextColor(255,255,255);doc.setFontSize(7.5);doc.setFont('helvetica','bold')
  let cx=M+2;hdrs.forEach((h,i)=>{t(h,cx,y+5.5);cx+=cols[i]});y+=RH
  const docList=Array.isArray(f.documents)&&f.documents.length>0?f.documents:[{document:'Attestation de cession',reference:f.animalId||'\u2014',nombre:'1',date:f.date||f.doc?.date}]
  const docRows=docList.map((row,ri)=>[String(ri+1),safe(row.document||''),safe(row.nombre||'1'),safe(row.reference||''),fmt(row.date)])
  const pageBottom=H-10
  docRows.forEach((row,ri)=>{const bg=ri%2===0;doc.setFillColor(bg?255:248,bg?255:250,bg?255:252);doc.rect(M,y,CW,RH,'F');doc.setDrawColor(203,213,225);doc.setLineWidth(0.15);doc.rect(M,y,CW,RH);doc.setTextColor(30,41,59);doc.setFontSize(7.5);doc.setFont('helvetica','normal');let cx2=M+2;row.forEach((cell,ci)=>{t(safe(cell||'').slice(0,ci===1?45:18),cx2,y+5.5);cx2+=cols[ci]});let xAcc=M;cols.forEach((cw)=>{xAcc+=cw;doc.setDrawColor(203,213,225);doc.setLineWidth(0.15);doc.line(xAcc,y,xAcc,y+RH)});y+=RH})
  y+=6
  if(y+55>H-12>pageBottom){doc.addPage();doc.setFillColor(18,34,74);doc.rect(0,H-10,W,10,'F');doc.setFillColor(217,174,92);doc.rect(0,H-10,W,0.8,'F');doc.setTextColor(180,200,230);doc.setFontSize(6.5);doc.setFont('helvetica','normal');t('ANIMAUX POUR ADOPTION DE LA FRANCE - '+(f.cedantAdresse||'123 Rue des Compagnons, 75001 Paris'),W/2,H-4,{align:'center'});y=20}
  const sigW=(CW-6)/2,sigX2=M+sigW+6,sigH=32
  doc.setFontSize(9);doc.setFont('helvetica','bold');doc.setTextColor(30,41,59)
  t('Signature du Prestataire',M+sigW/2,y,{align:'center'});t('Signature du Client',sigX2+sigW/2,y,{align:'center'});y+=6
  doc.setFillColor(248,250,252);doc.rect(M,y,sigW,sigH,'F');doc.setDrawColor(203,213,225);doc.setLineWidth(0.15);doc.rect(M,y,sigW,sigH)
  if(adminSig){try{doc.addImage(adminSig,'PNG',M+3,y+2,sigW-6,sigH-8)}catch(e){}}
  doc.setDrawColor(100,116,139);doc.setLineWidth(0.15);doc.line(M+3,y+sigH-8,M+sigW-3,y+sigH-8)
  doc.setTextColor(30,41,59);doc.setFontSize(7.5);doc.setFont('helvetica','normal');t(safe(f.cedantNom||'Animaux pour Adoption de la France'),M+3,y+sigH-4)
  doc.setFillColor(248,250,252);doc.rect(sigX2,y,sigW,sigH,'F');doc.setDrawColor(203,213,225);doc.setLineWidth(0.15);doc.rect(sigX2,y,sigW,sigH)
  if(userSig){try{doc.addImage(userSig,'PNG',sigX2+3,y+2,sigW-6,sigH-8)}catch(e){}}else{doc.setTextColor(148,163,184);doc.setFontSize(7.5);doc.setFont('helvetica','italic');t('En attente de signature',sigX2+sigW/2,y+sigH/2,{align:'center'})}
  doc.setDrawColor(100,116,139);doc.setLineWidth(0.15);doc.line(sigX2+3,y+sigH-8,sigX2+sigW-3,y+sigH-8)
  doc.setTextColor(30,41,59);doc.setFontSize(7.5);doc.setFont('helvetica','normal');t(safe(f.acquereurNom||f.clientNom||'Client'),sigX2+3,y+sigH-4)
  y+=sigH+6
  doc.setFillColor(18,34,74);doc.rect(0,H-10,W,10,'F');doc.setFillColor(217,174,92);doc.rect(0,H-10,W,0.8,'F')
  doc.setTextColor(180,200,230);doc.setFontSize(6.5);doc.setFont('helvetica','normal');t('ANIMAUX POUR ADOPTION DE LA FRANCE - '+(f.cedantAdresse||'123 Rue des Compagnons, 75001 Paris'),W/2,H-4,{align:'center'})
  doc.save('cession-'+(f.animalNom||f.animalEspece||'animal').replace(/\s+/g,'-').replace(/[^\x00-\xFF]/g,'')+'.pdf')
}

/* ─────────────────────────────────────────────────────────────
   Icônes
───────────────────────────────────────────────────────────── */
const IcoBack = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>)
const IcoCheck = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>)
const IcoDot = () => (<svg width="8" height="8" viewBox="0 0 8 8" fill="none"><circle cx="4" cy="4" r="4" fill="var(--gold)"/></svg>)
const IcoClose = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>)
const IcoDownload = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>)
const IcoLock = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>)

/* ─────────────────────────────────────────────────────────────
   Données
───────────────────────────────────────────────────────────── */
const PRESTATIONS = [
  "Vérification complète des documents de l'animal avant le départ.",
  "Préparation du dossier administratif.",
  "Obtention et vérification du passeport européen pour animaux (si nécessaire).",
  "Vérification de l'identification par puce électronique.",
  "Contrôle du carnet de santé.",
  "Vérification des vaccinations obligatoires (rage et autres selon le pays de destination).",
  "Organisation des certificats vétérinaires.",
  "Certificat de bonne santé délivré par un vétérinaire agréé.",
  "Certificat sanitaire international lorsque celui-ci est exigé.",
  "Gestion des formalités douanières.",
  "Assistance pour les formalités d'importation et d'exportation.",
  "Vérification des conditions d'entrée selon le pays de destination.",
  "Préparation des documents demandés par les compagnies aériennes.",
  "Réservation du transport conformément aux exigences des compagnies.",
  "Vérification des normes IATA relatives à la caisse de transport.",
  "Déclaration des animaux auprès des transporteurs.",
  "Gestion des autorisations administratives particulières si nécessaire.",
  "Accompagnement administratif jusqu'à la livraison.",
]

const POURQUOI = [
  "Gain de temps", "Aucune démarche compliquée à effectuer",
  "Conformité avec les réglementations internationales",
  "Équipe spécialisée dans le transport animalier",
  "Suivi personnalisé de votre dossier",
  "Vérification complète avant le départ",
  "Assistance jusqu'à la remise de votre animal",
]

// Documents cliquables (admin peut générer) vs non-cliquables
const DOCUMENTS = [
  { label: 'Passeport européen',                      clickable: false },
  { label: 'Carnet de santé',                         clickable: true,  docType: 'carnet',         emoji: '📋' },
  { label: 'Certificat vétérinaire',                  clickable: true,  docType: 'attestation',    emoji: '🩺' },
  { label: 'Certificat sanitaire international',      clickable: false },
  { label: 'Certificat de cession',                   clickable: true,  docType: 'cession',        emoji: '📜' },
  { label: 'Facture de vente ou d\'adoption',         clickable: false },
  { label: 'Attestation d\'identification',           clickable: true,  docType: 'identification', emoji: '🪪' },
  { label: 'Documents douaniers',                     clickable: false },
  { label: 'Autorisations d\'importation / exportation', clickable: false },
  { label: 'Documents exigés par les compagnies aériennes', clickable: false },
]

/* ─────────────────────────────────────────────────────────────
   Modale User — liste ses docs d'un type
───────────────────────────────────────────────────────────── */
const SIG_PER_PAGE = 5

function UserDocsModal({ docType, emoji, label, onClose }) {
  const [docs, setDocs]         = useState([])
  const [loading, setLoading]   = useState(true)
  const [page, setPage]         = useState(1)
  const [signing, setSigning]   = useState(null)   // doc en cours de signature
  const [saving, setSaving]     = useState(false)
  const [dlId, setDlId]         = useState(null)
  const canvasRef               = useRef(null)
  const drawingRef              = useRef(false)
  const lastRef                 = useRef(null)
  useBodyScrollLock(true) // bloque le scroll body pendant que la modale est ouverte

  useEffect(() => {
    animalDocsAPI.getMyDocs()
      .then(d => setDocs((d.docs || []).filter(x => x.docType === docType)))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [docType])

  // ── Canvas signature ──
  const initCanvas = (el) => {
    if (!el) return
    canvasRef.current = el
    const ctx = el.getContext('2d')
    ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.strokeStyle = '#1e2a4a'
    const pos = (e) => {
      const r = el.getBoundingClientRect()
      const t = e.touches?.[0] || e
      return { x: (t.clientX - r.left) * (el.width / r.width), y: (t.clientY - r.top) * (el.height / r.height) }
    }
    const start = (e) => { e.preventDefault(); drawingRef.current = true; lastRef.current = pos(e); ctx.beginPath(); ctx.moveTo(lastRef.current.x, lastRef.current.y) }
    const move  = (e) => { e.preventDefault(); if (!drawingRef.current) return; const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); lastRef.current = p }
    const stop  = () => { drawingRef.current = false }
    el.addEventListener('mousedown', start); el.addEventListener('mousemove', move)
    el.addEventListener('mouseup', stop);    el.addEventListener('mouseleave', stop)
    el.addEventListener('touchstart', start, { passive: false })
    el.addEventListener('touchmove', move,  { passive: false })
    el.addEventListener('touchend', stop)
  }
  const clearCanvas = () => { const el = canvasRef.current; if (el) el.getContext('2d').clearRect(0, 0, el.width, el.height) }
  const exportSig   = () => {
    const el = canvasRef.current; if (!el) return null
    const ctx = el.getContext('2d'); const d = ctx.getImageData(0, 0, el.width, el.height).data
    if ([...d].every((v, i) => i % 4 !== 3 || v === 0)) return null
    return el.toDataURL('image/png')
  }

  const downloadDoc = async (docLight) => {
    setDlId(docLight._id)
    try {
      // Fetcher le doc complet (avec signatures + payload) au moment du téléchargement
      const res  = await animalDocsAPI.getMyDoc(docLight._id)
      const doc  = res.doc
      let p = {}
      try { p = doc.payload ? JSON.parse(doc.payload) : {} } catch(pe) {}
      if (doc.docType === 'carnet')         await generateCarnetPDF(p.d||{}, p.vaccins||[], p.antiparas||[], doc.adminSignature||null, p.photo||null, p.cachet||null)
      if (doc.docType === 'attestation')    await generateAttestationPDF(p.d||{}, doc.adminSignature||null, p.stamp||null)
      if (doc.docType === 'identification') await generateIdentificationPDF(p.d||{})
      if (doc.docType === 'cession')        await generateCessionPDF({...(p.d||{}),...doc}, doc.adminSignature||null, doc.userSignature||null)
    } catch (e) { alert('Erreur PDF : ' + (e.message || String(e))) }
    finally { setDlId(null) }
  }

  const handleSign = async () => {
    const sig = exportSig()
    if (!sig) { alert('Veuillez signer avant de valider.'); return }
    setSaving(true)
    try {
      const res  = await animalDocsAPI.userSign(signing._id, sig)
      const signed = { ...signing, ...res.doc, userSignature: sig }
      setDocs(prev => prev.map(d => d._id === signing._id ? signed : d))
      const p = signed.payload ? JSON.parse(signed.payload) : {}
      await generateCessionPDF({...(p.d||{}),...signed}, signed.adminSignature||null, sig)
      setSigning(null)
    } catch (e) { alert('Erreur : ' + (e.message || '')) }
    finally { setSaving(false) }
  }

  const total = docs.length
  const totalPages = Math.max(1, Math.ceil(total / SIG_PER_PAGE))
  const paged = docs.slice((page - 1) * SIG_PER_PAGE, page * SIG_PER_PAGE)

  // ── Écran signature ──
  if (signing) return (
    <div className="afp-modal-overlay">
      <div className="afp-modal-box" onClick={e => e.stopPropagation()}>
        <div className="afp-modal-head">
          <div className="afp-modal-title">✍️ Signer — {signing.docNumber}</div>
          <button className="afp-modal-close" onClick={() => setSigning(null)}><IcoClose /></button>
        </div>
        <div style={{ padding: '20px 24px 24px', display:'flex', flexDirection:'column', gap:14 }}>
          {signing.adminSignature && (
            <div style={{ padding:'12px 14px', background:'var(--bg)', borderRadius:8, border:'1px solid var(--border)' }}>
              <div style={{ fontSize:10, fontWeight:700, color:'var(--gold-dk)', textTransform:'uppercase', letterSpacing:'.07em', marginBottom:6 }}>Signature de l'administrateur</div>
              <img src={signing.adminSignature} alt="" style={{ height:52, border:'1px solid var(--border)', borderRadius:6, background:'#fff', padding:3, maxWidth:'100%', display:'block' }} />
            </div>
          )}
          <div>
            <div style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:8 }}>Votre signature</div>
            <canvas ref={initCanvas} width={520} height={120}
              style={{ border:'1.5px solid var(--border)', borderRadius:8, touchAction:'none', display:'block', background:'#fff', cursor:'crosshair', width:'100%' }} />
            <button style={{ marginTop:8, background:'none', border:'1px solid var(--border)', borderRadius:7, padding:'5px 12px', fontSize:12, color:'var(--slate)', cursor:'pointer' }} onClick={clearCanvas}>🗑 Effacer</button>
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button className="afp-modal-doc-btn" style={{ padding:'10px 20px', fontSize:13 }} disabled={saving} onClick={handleSign}>
              {saving ? '⏳ Envoi…' : '✓ Valider & télécharger le PDF signé'}
            </button>
            <button style={{ padding:'10px 16px', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:8, fontSize:13, color:'var(--slate)', cursor:'pointer' }} onClick={() => setSigning(null)}>Annuler</button>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="afp-modal-overlay">
      <div className="afp-modal-box" onClick={e => e.stopPropagation()}>
        <div className="afp-modal-head">
          <div className="afp-modal-title">{emoji} {label}</div>
          <button className="afp-modal-close" onClick={onClose}><IcoClose /></button>
        </div>
        {loading ? (
          <div className="afp-modal-empty"><div className="catalog-spinner" /></div>
        ) : docs.length === 0 ? (
          <div className="afp-modal-empty">
            <div style={{ fontSize: 40, marginBottom: 12 }}>📭</div>
            <div style={{ fontWeight: 700, color: 'var(--blue)', marginBottom: 8 }}>Aucun document disponible</div>
            <p style={{ fontSize: 13, color: 'var(--slate)', maxWidth: 320, textAlign: 'center', lineHeight: 1.6 }}>
              Votre conseiller vous enverra ce document une fois votre dossier traité. Vous recevrez une notification par e-mail.
            </p>
          </div>
        ) : (
          <>
            <div className="afp-modal-docs">
              {paged.map(doc => (
                <div key={doc._id} className="afp-modal-doc-row" style={!doc.readByUser ? { borderColor:'var(--gold)', background:'#FFFBF0' } : {}}>
                  <div className="afp-modal-doc-info">
                    <span className="afp-modal-doc-ref">{doc.docNumber || '—'}</span>
                    <span className="afp-modal-doc-animal">{doc.animalNom || '—'}{doc.animalEspece ? ` · ${doc.animalEspece}` : ''}</span>
                    <span className="afp-modal-doc-date">{doc.date || '—'}</span>
                    <span className={`afp-modal-doc-status ${doc.signatureStatus}`}>
                      {doc.signatureStatus === 'signed' ? '✅ Signé' : (doc.docType === 'cession' && doc.signatureStatus === 'awaiting_user') ? '⏳ À signer' : '📄 Envoyé'}
                    </span>
                  </div>
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    {doc.docType === 'cession' && doc.signatureStatus === 'awaiting_user' && (
                      <button className="afp-modal-doc-btn" style={{ background:'var(--gold)', color:'var(--blue)' }} onClick={() => setSigning(doc)}>
                        ✍️ Signer
                      </button>
                    )}
                    <button className="afp-modal-doc-btn" disabled={dlId === doc._id} onClick={() => downloadDoc(doc)}>
                      {dlId === doc._id ? '⏳' : <><IcoDownload /> PDF</>}
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {totalPages > 1 && (
              <div className="afp-modal-pagination">
                <button className="afp-pg-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>‹</button>
                <span className="afp-pg-info">{page} / {totalPages}</span>
                <button className="afp-pg-btn" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>›</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

/* ─────────────────────────────────────────────────────────────
   Modale Admin — formulaire de création
───────────────────────────────────────────────────────────── */
const ADM_PER_PAGE = 5

function AdminFormModal({ docType, emoji, label, users, onClose, onCreated }) {
  const [toast, setToast]       = useState('')
  const [view, setView]         = useState('list') // 'list' | 'form'
  const [docs, setDocs]         = useState([])
  const [docsLoading, setDocsLoading] = useState(true)
  const [page, setPage]         = useState(1)
  const [dlId, setDlId]         = useState(null)
  useBodyScrollLock(true) // bloque le scroll body pendant que la modale est ouverte
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3500) }

  useEffect(() => {
    setDocsLoading(true)
    animalDocsAPI.getAll(docType)
      .then(d => setDocs(d.docs || []))
      .catch(() => {})
      .finally(() => setDocsLoading(false))
  }, [docType, view]) // re-fetch aussi quand on revient à la liste

  const handleGenerate = async (type, ...args) => {
    try {
      let payload = {}
      if (type === 'carnet') {
        const [d, vaccins, antiparas, sig, photo, cachet, userResolved] = args
        payload = { docType:'carnet', animalNom:d.name, animalEspece:d.species, clientNom:userResolved?.name||d.proprietaire_nom, clientEmail:userResolved?.email||d.proprietaire_email, date:d.attestation_date, payload:JSON.stringify({d,vaccins,antiparas,photo:photo||null,cachet:cachet||null}), adminSignature:sig||null }
        const res = await animalDocsAPI.create(payload)
        await generateCarnetPDF(d, vaccins, antiparas, sig, photo, cachet)
        showToast('Carnet créé & PDF généré ✓')
        setDocs(prev => [res.doc, ...prev])
        onCreated(res.doc); setView('list')
        try { new BroadcastChannel('app_sync_event').postMessage({ type:'new_doc' }) } catch(e) {}
      } else if (type === 'attestation') {
        const [d, sig, stamp, userResolved] = args
        payload = { docType:'attestation', animalNom:d.animalNom, animalEspece:d.animalEspece, clientNom:userResolved?.name||d.proprietaireNom, clientEmail:userResolved?.email||'', date:d.date, payload:JSON.stringify({d,stamp:stamp||null}), adminSignature:sig||null }
        const res = await animalDocsAPI.create(payload)
        await generateAttestationPDF(d, sig, stamp)
        showToast('Attestation créée & PDF généré ✓')
        setDocs(prev => [res.doc, ...prev])
        onCreated(res.doc); setView('list')
        try { new BroadcastChannel('app_sync_event').postMessage({ type:'new_doc' }) } catch(e) {}
      } else if (type === 'identification') {
        const [d, userResolved] = args
        payload = { docType:'identification', animalNom:d.animalName, animalEspece:d.animalEspece, clientNom:userResolved?.name||d.ownerName, clientEmail:userResolved?.email||d.email, date:new Date().toISOString().split('T')[0], payload:JSON.stringify({d}), adminSignature:null }
        const res = await animalDocsAPI.create(payload)
        await generateIdentificationPDF(d)
        showToast('Identification créée & PDF généré ✓')
        setDocs(prev => [res.doc, ...prev])
        onCreated(res.doc); setView('list')
        try { new BroadcastChannel('app_sync_event').postMessage({ type:'new_doc' }) } catch(e) {}
      } else if (type === 'cession') {
        const [d, sig, userResolved] = args
        payload = { docType:'cession', animalNom:d.animalNom, animalEspece:d.animalEspece, clientNom:userResolved?.name||d.acquereurNom, clientEmail:userResolved?.email||d.acquereurEmail, date:d.date, payload:JSON.stringify({d}), adminSignature:sig||null }
        const res = await animalDocsAPI.create(payload)
        await generateCessionPDF({...d,...res.doc}, sig, null)
        showToast(sig ? 'Cession créée & envoyée pour co-signature ✓' : 'Cession créée ✓')
        setDocs(prev => [res.doc, ...prev])
        onCreated(res.doc); setView('list')
        try { new BroadcastChannel('app_sync_event').postMessage({ type:'new_doc' }) } catch(e) {}
      }
    } catch (e) { showToast('Erreur : ' + (e.message || 'impossible')) }
  }

  const downloadDoc = async (docLight) => {
    setDlId(docLight._id)
    try {
      // Fetcher le doc complet (avec signatures + payload) via la route admin GET /:id
      const res     = await animalDocsAPI.getOne(docLight._id)
      const fullDoc = res.doc
      let p = {}
      try { p = fullDoc.payload ? JSON.parse(fullDoc.payload) : {} } catch(pe) {}
      // Toujours passer les 2 signatures — userSignature inclus si signé
      if (fullDoc.docType === 'carnet')         await generateCarnetPDF(p.d||{}, p.vaccins||[], p.antiparas||[], fullDoc.adminSignature||null, p.photo||null, p.cachet||null)
      if (fullDoc.docType === 'attestation')    await generateAttestationPDF(p.d||{}, fullDoc.adminSignature||null, p.stamp||null)
      if (fullDoc.docType === 'identification') await generateIdentificationPDF(p.d||{})
      if (fullDoc.docType === 'cession')        await generateCessionPDF({...(p.d||{}),...fullDoc}, fullDoc.adminSignature||null, fullDoc.userSignature||null)
    } catch (e) { showToast('Erreur PDF : ' + (e.message || String(e))) }
    finally { setDlId(null) }
  }

  const totalPages = Math.max(1, Math.ceil(docs.length / ADM_PER_PAGE))
  const paged = docs.slice((page - 1) * ADM_PER_PAGE, page * ADM_PER_PAGE)

  return (
    <div className="afp-modal-overlay">
      <div className="afp-modal-box afp-modal-box--form" onClick={e => e.stopPropagation()}>
        <div className="afp-modal-head">
          <div className="afp-modal-title">
            {view === 'list' ? <>{emoji} {label}</> : <>{emoji} Créer — {label}</>}
          </div>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            {view === 'list'
              ? <button className="afp-modal-doc-btn" style={{ padding:'7px 14px' }} onClick={() => setView('form')}>+ Nouveau</button>
              : <button style={{ padding:'6px 12px', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:8, fontSize:12, color:'var(--slate)', cursor:'pointer' }} onClick={() => setView('list')}>← Liste</button>
            }
            <button className="afp-modal-close" onClick={onClose}><IcoClose /></button>
          </div>
        </div>
        {toast && <div className="afp-modal-toast">{toast}</div>}

        {view === 'list' ? (
          docsLoading ? (
            <div className="afp-modal-empty"><div className="catalog-spinner" /></div>
          ) : docs.length === 0 ? (
            <div className="afp-modal-empty">
              <div style={{ fontSize:38, marginBottom:10 }}>{emoji}</div>
              <div style={{ fontWeight:700, color:'var(--blue)', marginBottom:8 }}>Aucun document créé</div>
              <button className="afp-modal-doc-btn" style={{ padding:'9px 20px', fontSize:13 }} onClick={() => setView('form')}>+ Créer le premier</button>
            </div>
          ) : (
            <>
              <div className="afp-modal-docs">
                {paged.map(doc => (
                  <div key={doc._id} className="afp-modal-doc-row">
                    <div className="afp-modal-doc-info">
                      <span className="afp-modal-doc-ref">{doc.docNumber || '—'}</span>
                      <span className="afp-modal-doc-animal">{doc.animalNom || '—'}{doc.animalEspece ? ` · ${doc.animalEspece}` : ''}</span>
                      <span className="afp-modal-doc-date">{doc.date || '—'}</span>
                      <span className="afp-modal-doc-animal" style={{ color:'var(--slate)' }}>{doc.clientNom || '—'}</span>
                      <span className={`afp-modal-doc-status ${doc.signatureStatus}`}>
                        {doc.signatureStatus === 'signed' ? '✅ Signé' : (doc.docType === 'cession' && doc.signatureStatus === 'awaiting_user') ? '⏳ Attente client' : '📄 Envoyé'}
                      </span>
                    </div>
                    <button className="afp-modal-doc-btn" disabled={dlId === doc._id} onClick={() => downloadDoc(doc)}>
                      {dlId === doc._id ? '⏳' : <><IcoDownload /> PDF</>}
                    </button>
                  </div>
                ))}
              </div>
              {totalPages > 1 && (
                <div className="afp-modal-pagination">
                  <button className="afp-pg-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>‹</button>
                  <span className="afp-pg-info">{page} / {totalPages}</span>
                  <button className="afp-pg-btn" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>›</button>
                </div>
              )}
            </>
          )
        ) : (
          <div className="afp-modal-form-body">
            {docType === 'carnet' && (
              <CarnetSanteForm show users={users} onClose={() => setView('list')}
                onGenerate={(d,vaccins,antiparas,sig,photo,cachet,userResolved) => handleGenerate('carnet',d,vaccins,antiparas,sig,photo,cachet,userResolved)} />
            )}
            {docType === 'attestation' && (
              <AttestationVetForm show users={users} onClose={() => setView('list')}
                onGenerate={(d,sig,stamp,userResolved) => handleGenerate('attestation',d,sig,stamp,userResolved)} />
            )}
            {docType === 'identification' && (
              <IdentificationForm show users={users} onClose={() => setView('list')}
                onGenerate={(d,userResolved) => handleGenerate('identification',d,userResolved)} />
            )}
            {docType === 'cession' && (
              <CessionForm show users={users} onClose={() => setView('list')}
                onGenerate={(d,sig,userResolved) => handleGenerate('cession',d,sig,userResolved)} />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

/* ─────────────────────────────────────────────────────────────
   Composant principal
───────────────────────────────────────────────────────────── */
export default function AdminFormalitesPage({ onBack, user, onAuthClick }) {
  const isLoggedIn = user?.loggedIn === true
  const isAdmin    = user?.role === 'admin'

  const [modal, setModal]   = useState(null) // { docType, label, emoji }
  const [users, setUsers]   = useState([])

  // Charger la liste des users si admin
  useEffect(() => {
    if (!isAdmin) return
    usersAPI.getAll({ limit: 100 })
      .then(d => setUsers((d.users || []).map(u => ({ id: u._id||u.id, name: u.name, email: u.email }))))
      .catch(() => {})
  }, [isAdmin])

  const handleDocClick = (doc) => {
    if (!doc.clickable) return
    if (!isLoggedIn) { if (onAuthClick) onAuthClick(); return }
    setModal(doc)
  }

  return (
    <div className="afp-root">
      {/* Topbar */}
      <div className="afp-topbar">
        <div className="afp-topbar-inner">
          <button className="afp-back-btn" onClick={onBack}><IcoBack /> Retour aux services</button>
          <nav className="afp-breadcrumb">
            <span className="afp-breadcrumb-link" onClick={onBack}>Services</span>
            <span className="afp-breadcrumb-sep">›</span>
            <span className="afp-breadcrumb-current">Formalités administratives</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <div className="afp-hero">
        <div className="afp-hero-inner">
          <div className="afp-eyebrow"><span className="afp-eyebrow-line" />SERVICE 02 — ADMINISTRATIF</div>
          <h1 className="afp-hero-title">Gestion des formalités<br />administratives</h1>
          <p className="afp-hero-sub">Nous prenons en charge l'ensemble des démarches administratives nécessaires afin de garantir un transport sécurisé, conforme à la réglementation nationale et internationale.</p>
          <p className="afp-hero-sub">Notre équipe s'occupe de préparer, vérifier et transmettre tous les documents obligatoires pour que votre animal puisse voyager dans les meilleures conditions.</p>
        </div>
      </div>

      {/* Contenu */}
      <div className="afp-content">

        {/* Prestations */}
        <section className="afp-section">
          <div className="afp-section-label"><span className="afp-section-num">01</span>Nos prestations comprennent</div>
          <h2 className="afp-section-title">Ce que nous prenons en charge</h2>
          <ul className="afp-list">
            {PRESTATIONS.map((item, i) => (
              <li key={i} className="afp-list-item-plain">
                <span className="afp-list-dot"><IcoDot /></span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Documents */}
        <section className="afp-section">
          <div className="afp-section-label"><span className="afp-section-num">02</span>Documents</div>
          <h2 className="afp-section-title">Documents que nous pouvons gérer</h2>

          {/* Bandeau rôle */}
          {!isLoggedIn && (
            <div className="afp-role-banner afp-role-banner--guest">
              <IcoLock /> Connectez-vous pour accéder à vos documents ou pour générer des documents (admin uniquement).
              <button className="afp-role-btn" onClick={onAuthClick}>Se connecter</button>
            </div>
          )}
          {isLoggedIn && !isAdmin && (
            <div className="afp-role-banner afp-role-banner--user">
              <IcoCheck /> Cliquez sur un document pour consulter vos fichiers envoyés par votre conseiller.
            </div>
          )}
          {isAdmin && (
            <div className="afp-role-banner afp-role-banner--admin">
              <IcoCheck /> Mode administrateur — cliquez sur un document pour créer et générer le fichier PDF.
            </div>
          )}

          <div className="afp-docs-grid">
            {DOCUMENTS.map((doc, i) => {
              const clickable = doc.clickable
              return (
                <div
                  key={i}
                  className={`afp-doc-card${clickable ? ' afp-doc-card--clickable' : ''}`}
                  onClick={() => handleDocClick(doc)}
                  title={clickable ? (isAdmin ? `Créer un ${doc.label}` : `Voir mes ${doc.label}s`) : undefined}
                >
                  <span className="afp-doc-icon"><IcoCheck /></span>
                  <span className="afp-doc-label">{doc.label}</span>
                  {clickable && (
                    <span className="afp-doc-badge">
                      {isAdmin ? 'Créer' : isLoggedIn ? 'Voir' : <IcoLock />}
                    </span>
                  )}
                </div>
              )
            })}
          </div>
        </section>

        {/* Pourquoi nous */}
        <section className="afp-section afp-why-section">
          <div className="afp-section-label"><span className="afp-section-num">03</span>Avantages</div>
          <h2 className="afp-section-title">Pourquoi choisir notre service ?</h2>
          <div className="afp-why-grid">
            {POURQUOI.map((reason, i) => (
              <div key={i} className="afp-why-item">
                <span className="afp-why-icon"><IcoCheck /></span>
                <span>{reason}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Engagement */}
        <section className="afp-engagement">
          <div className="afp-engagement-inner">
            <div className="afp-section-label afp-section-label--light"><span className="afp-section-num afp-section-num--light">04</span>Notre engagement</div>
            <h2 className="afp-engagement-title">Un service clé en main pour votre tranquillité</h2>
            <p className="afp-engagement-text">Notre priorité est de vous offrir un service clé en main. Nous nous assurons que chaque document est conforme aux exigences du pays de départ, de transit et de destination afin d'éviter tout retard, refus d'embarquement ou problème administratif.</p>
            <p className="afp-engagement-text">Votre animal voyage en toute sérénité grâce à une prise en charge administrative complète, du premier contact jusqu'à son arrivée à destination.</p>
          </div>
        </section>

      </div>

      {/* Modales */}
      {modal && isLoggedIn && !isAdmin && (
        <UserDocsModal
          docType={modal.docType}
          emoji={modal.emoji}
          label={modal.label}
          onClose={() => setModal(null)}
        />
      )}
      {modal && isAdmin && (
        <AdminFormModal
          docType={modal.docType}
          emoji={modal.emoji}
          label={modal.label}
          users={users}
          onClose={() => setModal(null)}
          onCreated={() => setModal(null)}
        />
      )}
    </div>
  )
}